import { render } from "./RodShop.vue?vue&type=template&id=df1489d6"
import script from "./RodShop.vue?vue&type=script&lang=js"
export * from "./RodShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__